import React from 'react';
import { Provider } from 'react-redux'
import store from './redux/store'
import Monitor from './Monitor'
import { startScanListener } from './Scan'
import './App.css'

startScanListener();

const App: React.FC = () => {

  return (
    <Provider store={store}>
      <div className="App">
        <Monitor />
      </div>      
    </Provider>
  );
}

export default App;
